import { render, staticRenderFns } from "./PayStepTip.vue?vue&type=template&id=79905596&"
import script from "./PayStepTip.vue?vue&type=script&setup=true&lang=js&"
export * from "./PayStepTip.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PayStepTip.vue?vue&type=style&index=0&id=79905596&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports